import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router";
import { api, STAGES, type Project } from "../api";

export function NewProject() {
  const nav = useNavigate();
  const qc = useQueryClient();
  const [f, setF] = useState({ slug: "", name: "", description: "", client: "", repo: "", stage: "build", contact: "" });
  const set = (k: keyof typeof f) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => setF({ ...f, [k]: e.target.value });
  const create = useMutation({
    mutationFn: () => api<Project>("/projects", { method: "POST", body: JSON.stringify(f) }),
    onSuccess: (p) => {
      qc.invalidateQueries({ queryKey: ["projects"] });
      qc.invalidateQueries({ queryKey: ["overview"] });
      nav(`/p/${p.slug}`);
    },
  });

  return (
    <form className="canvas" onSubmit={(e) => { e.preventDefault(); create.mutate(); }}>
      <div className="title-row">
        <div>
          <h1>New project</h1>
          <p className="sub">Record the project; its environments run on the lab host and are added from its page.</p>
        </div>
      </div>

      <div>
        <div className="form-row">
          <div className="label"><h3>What it is</h3><p>The name people use, and a slug that becomes its subdomains and stack names: <span className="mono">acme</span> gives <span className="mono">acme.scdev.io</span>.</p></div>
          <div className="form-panel">
            <div className="form-grid">
              <label className="field"><span>Name</span><input className="input" value={f.name} onChange={set("name")} required /></label>
              <label className="field">
                <span>Slug</span>
                <input className="input mono" value={f.slug} onChange={set("slug")} pattern="[a-z][a-z0-9-]{1,38}" required aria-describedby="slug-hint" />
                <span className="hint" id="slug-hint">Lowercase letters, digits and hyphens; starts with a letter.</span>
              </label>
            </div>
            <label className="field"><span>Description</span><textarea className="input" value={f.description} onChange={set("description")} placeholder="What it does and for whom, in two lines." /></label>
          </div>
        </div>
        <div className="form-row">
          <div className="label"><h3>Who and where</h3><p>The client it is for, who answers questions about it, and its code.</p></div>
          <div className="form-panel">
            <div className="form-grid">
              <label className="field"><span>Client</span><input className="input" value={f.client} onChange={set("client")} /></label>
              <label className="field"><span>Contact</span><input className="input" value={f.contact} onChange={set("contact")} /></label>
              <label className="field"><span>Bitbucket repository</span><input className="input mono" value={f.repo} onChange={set("repo")} placeholder="525k/acme" /></label>
              <label className="field"><span>Stage</span>
                <select className="input" value={f.stage} onChange={set("stage")}>{STAGES.map((s) => <option key={s}>{s}</option>)}</select>
              </label>
            </div>
            {create.error && <p className="error">{create.error.message}</p>}
            <div className="actions">
              <button className="btn primary" disabled={create.isPending}>{create.isPending ? "Creating…" : "Create project"}</button>
              <button type="button" className="btn" onClick={() => nav(-1)}>Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
